// import NetworkConfig from './network-config'

import NetworkConfig from './network-config';

/**
 * All networking url used in this app
 */
export default class NetworkUrls {
  static get baseApiUrl() {
    return process.env.BASE_API_HOST;
  }

  static get graphql() {
    return process.env.GRAPHQL_HOST;
  }

  static get langTexts() {
    return `${NetworkUrls.baseApiUrl}/lang`;
  }

  static get roomAvailability() {
    return `${NetworkUrls.baseApiUrl}/app/rooms`;
  }

  static get login() {
    return `${NetworkUrls.baseApiUrl}/auth/login`;
  }

  static get refresh() {
    return `${NetworkUrls.baseApiUrl}/auth/refresh`;
  }

  static get salonUrl () {
    return 'https://ressources.mihotel.fr/salle-de-reunion-lyon';
  }

  static get MiHPublicApi () {
    return 'https://mihotel-public.ubg-interactive.com/api';
  }

  static get faqCategories () {
    return this.MiHPublicApi + '/v1/faq/categories';
  }

  static get faqSearch () {
    return this.MiHPublicApi + '/v1/search';
  }
}



// WEBPACK FOOTER //
// ./src/network/network-urls.js